<template>
  <div class="app-modal-dialog--template-management app-modal-dialog">
    <div class="app-modal-dialog__content">

      <div class="app-modal-dialog__header">
          <div class="app-modal-dialog__titles">
              <div class="app-tab-navigation">
                <div class="app-tab-navigation__breadcrumbs">
                    <a v-if="returnUrl" class="app-tab-navigation__breadcrumb" :href="returnUrl">
                      <svg class="element-icon--breadcrumb element-icon" width="1em" height="1em">
                        <use href="/img/icons.svg#icon-arrow-left"></use>
                      </svg>
                      Back to Export
                    </a>
                </div>
              </div>
              <h4 class="app-modal-dialog__title">Manage MS PowerPoint Templates</h4>
          </div>
      </div>

      <div class="app-modal-dialog__body">

        <app-error
          v-if="hasErrors"
          class="is--inline"
          v-bind="errors"
        />

        <div class="app-modal-dialog__template-info grid">
          <p class="col-12 col-sm-8 col-md-9">Download the Starter Template and follow the instructions below to create your own branded PPT template. Note that there are specific rules regarding text and each slide’s object name when exporting to PPT; modifying or removing these elements will exclude them from the export. <span v-show="hasSlideJson">Click <a :href="`${templateDownloadUrl}/${pptSlideJsonPath}`" target="_blank">here</a> to download the slide JSON file for reference.</span></p>

          <div v-if="templateOptionSources && Object.keys(templateOptionSources).length" class="app-modal-dialog__template-downloads col-12 col-sm-4 col-md-3">
              <a v-for="(path, key) in templateOptionSources"
                  :key="key"
                  class="element-button element-button--primary"
                  target="_blank"
                  :href="`${templateDownloadUrl}/${path.path}`">
                <svg class="element-icon--download element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-download"></use></svg>
                {{ path.label }}
              </a>
          </div>
        </div>

        <details class="app-accordion">
            <summary class="app-accordion__header">
                <h4 class="app-accordion__title">Instructions</h4>
                <svg class="element-icon--chevron-down element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-down"></use></svg>
            </summary>
            <div class="app-accordion__body">
              <ol>
                <li><strong>Edit the Slide Master:</strong> Open the downloaded PPT file and navigate to the Slide Master view (Select View, then Slide Master), where you can change colors, fonts, the background graphic, and the logo. </li>
                <li><strong>IMPORTANT:</strong> Do NOT change <em>any</em> existing text, add or delete text boxes, or change object names (which can be found in the Selection Pane by navigating to Home > Select > Selection Pane). </li>
                <li><strong>Upload Your Custom Template:</strong> After saving your template, upload it below.</li>
                <li><strong>Select Your Template:</strong> After uploading your template, press the Back to Export arrow to return to the PPT export you were working in, then select your new template for use in your digital learning courses.</li>
              </ol>
            </div>
        </details>
        <template-manager-lite
          class="app-project-sources-upload__section-body"
          ref="manager"
          :source="templateSource"
          :files="assetFiles"
          :valid-extensions="validExtensions"
          :valid-mime-types="validMimeTypes"
          :max-file-size="maxFileSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  components: {  },
  props: {
    project: {
      type: Object,
    },
    item: {
      type: Object,
    },
    templateDownloadUrl: {
      type: String,
      default: '',
    },
    aiEnabled: {
      type: [Boolean, Number],
      default: false
    },
    assetFiles: {
      type: Object
    },
    templateSource: {
      type: String,
    },
    templateOptionSources: {
      type: Object
    },
    pptSlideJsonPath: {
      type: String,
      default: ''
    },
    validExtensions: {
      type: Object,
      default: () => { "pptx" }
    },
    validMimeTypes: {
      type: Object,
      default: () => ({})
    },
    maxFileSize: {
      type: Number,
      default: (50 * 1024 * 1024) // 50MB
    },
    returnUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      source: this.item || {},
      disabled: false,
      showConfirmation: false,
      errorMessage: null,
      errors: []
    }
  },
  computed: {
    hasSlideJson() {
      return this.pptSlideJsonPath && this.pptSlideJsonPath.length > 0
    },
    hasErrors () {
      return this.errorMessage || (this.errors?.message ?? this.errors?.errors?.message)
    },
    ...mapGetters('assets', {
      allFiles: 'fileSet',
    }),
  },
  methods: {
    
  },
  created() {

  }
}
</script>
